import { ActionName } from 'api/endpoints/action-names';
import { ContractActionName } from 'api/endpoints/contractActionNames';

export const filterExistingActionNames = <T extends ActionName | ContractActionName>(
  actionNames: T[],
): T[] => actionNames.filter((actionName) => actionName.id > 0);
